import React from 'react';

interface SegmentsTableErrorProps {
  error: unknown;
}

export const SegmentsTableError: React.FC<SegmentsTableErrorProps> = ({
  error,
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="text-center">
        <div className="text-red-600 font-medium">Error loading segments</div>
        <div className="text-gray-500 text-sm mt-1">
          {error instanceof Error
            ? error.message
            : 'An unexpected error occurred'}
        </div>
      </div>
    </div>
  );
};
